import {
  Component,
  ChangeDetectionStrategy,
  inject,
  OnDestroy,
  OnInit,
  ChangeDetectorRef,
} from '@angular/core';

import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import {
  DialogService,
  DynamicDialogConfig,
} from 'primeng/dynamicdialog';

import { AccordionModule } from 'primeng/accordion';
import { TimelineModule } from 'primeng/timeline';
import { TagModule } from 'primeng/tag';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { TableGenericComponent } from '@/shared/components/general/table-generic/table-generic.component';

import {
  FormGroup,
  ReactiveFormsModule,
} from '@angular/forms';

import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { LayoutService } from '@/layout/service/layout.service';
import { MainBase } from '@/abstract/MainBase.abstract';
import { FormConfig } from '@/interface/IDynamicCrud';
import { TableService } from './service/table.service';
import { GeneralService } from './service/general.service';
import { FormBuilderService } from './service/form-builder.service';
import { IProgramaPermiso } from '@/interface/general/IProgramaPermiso.interface';
import {
  IResponseApiGeneric,
  IResponseApiSS,
} from '@/interface/general/IResponseApi';

import { TypeResponse } from '@/common/enums/general/TypeResponse';
import { IConfiguracionSistema } from '../../../../pages/radicacion/flujo-doc-procesos/interfaces/flujo-doc-procesos.interface';
import { IFirmaDigitalForm } from '@/pages/configuraciones/flujo-doc/firma-digital/interface/dinamic-form.interface';
import {
  IActionEventCrud,
} from '@/common/enums/general.enum';
import { FooterModalService } from '@/shared/components/general/footer-modal/footer-modal.service';
import {
  takeUntilDestroyed,
  toObservable,
} from '@angular/core/rxjs-interop';
import {
  EFileType,
  FilePreviewComponent,
} from '@/shared/components/general/file-preview/file-preview.component';
import { FooterComponent } from '@/shared/components/footer';
import { ModalGenericComponent } from '@/shared/components/general/modal-generic/modal-generic.component';
import { forkJoin } from 'rxjs';
import { ITimeLineCabecera, ITimelineDocumento, ITimeLineHistorico, ITimeLineResponse } from './interface/dinamic-form.interface';

// ============================================================
// INTERFACE DEL TIMELINE
// ============================================================
// ============================================================
// COMPONENT
// ============================================================

@Component({
  selector: 'app-modal-timeline-documento',
  standalone: true,
  providers: [DialogService],

  imports: [
    CommonModule,
    ReactiveFormsModule,
    ButtonModule,
    AccordionModule,
    TimelineModule,
    TagModule,
    ProgressSpinnerModule,
    TableGenericComponent,
    ToastModule,
  ],

  templateUrl:'./modal-timeline-documento.component.html',
  styleUrl:'./modal-timeline-documento.component.scss',

  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModalTimelineDocumentoComponent extends MainBase implements OnDestroy, OnInit {
  cabeceraTimeline: ITimeLineCabecera | null = null;

  // ==========================================================
  // MAIN BASE
  // ==========================================================

  override onSubmit(): void {
    throw new Error(
      'Method not implemented.'
    );
  }
  // ==========================================================
  // CONFIGURACIÓN GENERAL
  // ==========================================================
  currentColumns = 2;
  showFormData = false;
  formConfig!: FormConfig;
  isEditMode = false;
  idArchivoResaltado:number | null = null;
  timeline: ITimelineDocumento[] = [];
  public showModalNewRegister = false;
  // ==========================================================
  // DOCUMENTO
  // ==========================================================
  idfdArchivo = '';
  documento: any = null;
  // ==========================================================
  // TIMELINE
  // ==========================================================
  loadingTimeline = false;
  totalEventos = 0;
  totalEstados = 0;
  totalUsuarios = 0;
  estadoActual =  'Sin información';
  // ==========================================================
  // SERVICES
  // ==========================================================
  tableService =  inject(TableService);
  titleService =  inject(LayoutService);
  layoutService =  inject(LayoutService);
  generalService = inject(GeneralService);
  formBuilderService = inject(FormBuilderService);
  public footerService =  inject(FooterModalService);
  private cdr = inject(ChangeDetectorRef);
  // ==========================================================
  // FORM
  // ==========================================================
  formGroup!: FormGroup<IFirmaDigitalForm>;
  // ==========================================================
  // CONSTRUCTOR
  // ==========================================================
  constructor(
    public dialogService: DialogService,
    private messageService: MessageService,
    public config:DynamicDialogConfig<IActionEventCrud<any>>
  ) {

    super();
    // --------------------------------------------------------
    // ACCIÓN INICIAL
    // --------------------------------------------------------
    this.actionToDo();
    // --------------------------------------------------------
    // FOOTER
    // --------------------------------------------------------

    this.footerService.resetButton();

    toObservable(this.footerService.presstButton)
      .pipe(
        takeUntilDestroyed()
      )
      .subscribe(
        (pressAction) => {

          switch (
            pressAction.action
          ) {
            case 'ver': this.onVerDocumentosConcatenados();
              break;
            case 'comparar': this.onComparar();
              break;
            default:
              console.warn(
                '⚠️ Acción no reconocida:',
                pressAction
              );
          }
        }
      );
  }

  // ==========================================================
  // DESTROY
  // ==========================================================

  ngOnDestroy(): void {
  }

  // ==========================================================
  // INIT
  // ==========================================================

  ngOnInit(): void {
    // Configuración de la tabla
    this.tableService.setHeaderTable();
    // Obtener documento
    const record = this.config.data?.record;
    if (!record?.IdfdArchivo) {
      console.warn(
        '⚠️ No se recibió IdfdArchivo para el Timeline'
      );
      return;
    }

    // Guardamos ID
    this.idfdArchivo = String(record.IdfdArchivo);
    // Guardamos documento
    this.documento = record;
    // Actualizamos el servicio
    this.tableService.IdfdArchivo = this.idfdArchivo;
    // Cargar Timeline
    this.cargarTimeline();
  }

  // ==========================================================
  // ACTION TO DO
  // ==========================================================

  actionToDo(): void {
    const record =  this.config.data?.record;
    if ( record?.IdfdArchivo) {

      this.tableService.IdfdArchivo =
        String(
          record.IdfdArchivo
        );
    }
  }

  // ==========================================================
  // TIMELINE
  // ==========================================================

  /**
   * Carga la hoja de vida del documento.
   *
   * Utiliza el mismo endpoint:
   *
   * FlujoDoc/GetDocRelacionados
   */
    cargarTimeline(): void {

      console.log('🚀 cargarTimeline INICIO');
      console.log('📌 IdfdArchivo:', this.idfdArchivo);

      if (!this.idfdArchivo) {

        console.warn(
          '⚠️ No existe IdfdArchivo'
        );

        this.loadingTimeline = false;

        this.cdr.markForCheck();

        return;
      }

      this.loadingTimeline = true;

      this.cdr.markForCheck();

      console.log(
        '📡 Llamando loadTimeline...'
      );

      this.tableService
        .loadTimeline(this.idfdArchivo)
        .subscribe({

          // =====================================================
          // SUCCESS
          // =====================================================

          next: (response: ITimeLineResponse) => {

            console.log(
              '📋 Timeline documento:',
              response
            );

            const cabecera =
              response?.data?.Cabecera;

            const historico =
              response?.data?.Historico ?? [];

            console.log(
              '📌 Cabecera:',
              cabecera
            );

            console.log(
              '📜 Histórico:',
              historico
            );

            console.log(
              '📊 Cantidad eventos:',
              historico.length
            );

            // ---------------------------------------------------
            // CABECERA
            // ---------------------------------------------------

            this.cabeceraTimeline =
              cabecera;

            // ---------------------------------------------------
            // TIMELINE
            // ---------------------------------------------------

            try {

              this.procesarTimeline(
                historico
              );

              console.log(
                '✅ Timeline procesado:',
                this.timeline
              );

            } catch (error) {

              console.error(
                '❌ Error procesando Timeline:',
                error
              );

              this.timeline = [];

            }

            // ---------------------------------------------------
            // LOADING
            // ---------------------------------------------------

            this.loadingTimeline = false;

            console.log(
              '🔄 loadingTimeline:',
              this.loadingTimeline
            );

            // ---------------------------------------------------
            // FORZAR DETECCIÓN
            // ---------------------------------------------------

            this.cdr.markForCheck();

          },

          // =====================================================
          // ERROR
          // =====================================================

          error: (error) => {

            console.error(
              '❌ Error cargando Timeline:',
              error
            );

            this.timeline = [];

            this.totalEventos = 0;

            this.totalEstados = 0;

            this.totalUsuarios = 0;

            this.estadoActual = 'Sin información';

            this.cabeceraTimeline = null;

            this.loadingTimeline = false;

            this.cdr.markForCheck();

            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail:
                'No se pudo cargar la trazabilidad del documento.',
              life: 5000,
            });

          },

          // =====================================================
          // COMPLETE
          // =====================================================

          complete: () => {

            console.log(
              '🏁 loadTimeline COMPLETE'
            );

            this.loadingTimeline = false;

            this.cdr.markForCheck();

          },

        });
    }

  // ==========================================================
  // PROCESAR TIMELINE
  // ==========================================================

   private procesarTimeline(
      registros: ITimeLineHistorico[]
    ): void {

      if (!registros || registros.length === 0) {

        this.timeline = [];
        this.totalEventos = 0;
        this.totalEstados = 0;
        this.totalUsuarios = 0;
        this.estadoActual = 'Sin información';

        return;
      }

      // ========================================================
      // ORDENAR MÁS RECIENTE PRIMERO
      // ========================================================

      const ordenados = [...registros].sort(
        (a, b) => {

          const fechaA = new Date(
            a.FechaRegistroHistorico ||
            a.FechaRegistro
          ).getTime();

          const fechaB = new Date(
            b.FechaRegistroHistorico ||
            b.FechaRegistro
          ).getTime();

          return fechaB - fechaA;
        }
      );

      // ========================================================
      // MAPEAR TIMELINE
      // ========================================================

      this.timeline = ordenados.map(
        (item, index) => {

          const estado =
            item.TipoDocumento ||
            'Sin estado';

         const accion =
                item.Tarea
                  ? `${item.IdfdPaso != null ? item.IdfdPaso + ' - ' : ''}${item.Tarea}`
                  : item.NombrePaso
                    ? `${item.IdfdPaso != null ? item.IdfdPaso + ' - ' : ''}${item.NombrePaso}`
                    : 'Evento documental';

              const descripcion =
                item.NombrePaso
                  ? `${item.IdfdPaso != null ? item.IdfdPaso + ' - ' : ''}${item.NombrePaso}`
                  : 'Sin descripción';

          const usuario =
            item.CodUserNombre ||
            item.CodUser ||
            'Sistema';

          const fecha =
            item.FechaRegistroHistorico ||
            item.FechaRegistro;

          return {

            fecha,

            estado,

            accion,

            descripcion,

            usuario,

            dependencia:
              item.NombreAgencia || '',

            consecutivo:
              item.CodRadicado || '',

            observacion:
              item.CmpoObservacion || '',

            icon:
              this.obtenerIconoEvento(
                estado,
                accion
              ),

            markerClass:
              this.obtenerClaseMarker(
                estado,
                accion
              ),

            severity:
              this.obtenerSeverity(
                estado,
                accion
              ),

            expanded:
              index === 0,

            archivos: [],

            // MUY IMPORTANTE
            // Conservamos TODO el registro original
            original: item
          };
        }
      );

      // ========================================================
      // ESTADÍSTICAS
      // ========================================================

      this.totalEventos =
        this.timeline.length;

      this.totalEstados =
        new Set(
          this.timeline
            .map(x => x.estado)
            .filter(Boolean)
        ).size;

      this.totalUsuarios =
        new Set(
          this.timeline
            .map(x => x.usuario)
            .filter(Boolean)
        ).size;

      // ========================================================
      // ESTADO ACTUAL
      // ========================================================

      this.estadoActual =  this.timeline[0]?.estado || 'Sin información';
    }

    // ==========================================================
    // ICONOS
    // ==========================================================

  private obtenerIconoEvento(estado: string,accion: string): string {
    const texto = `${estado} ${accion}`.toLowerCase();
    
    if (texto.includes('cread') ||
      texto.includes('radic')
    ) {
      return 'pi pi-file';
    }

    if (texto.includes('envi') ||
      texto.includes('remit')
    ) {
      return 'pi pi-send';
    }

    if (texto.includes('recib') ||
      texto.includes('recep')
    ) {
      return 'pi pi-inbox';
    }

    if (
      texto.includes('aproba') ||
      texto.includes('finaliz')
    ) {
      return 'pi pi-check-circle';
    }

    if (
      texto.includes('rechaz') ||
      texto.includes('devuelt')
    ) {
      return 'pi pi-times-circle';
    }

    if (
      texto.includes('archiv') ||
      texto.includes('expediente')
    ) {

      return 'pi pi-folder';
    }

    if (texto.includes('modific') || texto.includes('edit')
    ) {
      return 'pi pi-pencil';
    }

    if (
      texto.includes('firma')
    ) {
      return 'pi pi-verified';
    }

    return 'pi pi-history';
  }

  // ==========================================================
  // CLASE MARKER
  // ==========================================================

  private obtenerClaseMarker(
    estado: string,
    accion: string
  ): string {

    const texto = `${estado} ${accion}`.toLowerCase();

    if (
      texto.includes('aproba') ||
      texto.includes('finaliz') ||
      texto.includes('activo')
    ) {

      return 'bg-green-100 text-green-600';
    }

    if (
      texto.includes('rechaz') ||
      texto.includes('error')
    ) {
      return 'bg-red-100 text-red-600';
    }

    if (
      texto.includes('archiv') ||
      texto.includes('expediente')
    ) {
      return 'bg-orange-100 text-orange-600';
    }

    if (
      texto.includes('envi') ||
      texto.includes('recib')
    ) {
      return 'bg-blue-100 text-blue-600';
    }

    if (
      texto.includes('modific') ||
      texto.includes('edit')
    ) {
      return 'bg-purple-100 text-purple-600';
    }

    return 'bg-surface-200 text-color-secondary';
  }

  // ==========================================================
  // SEVERITY
  // ==========================================================

  private obtenerSeverity(estado: string,accion: string):
    | 'success'
    | 'info'
    | 'warn'
    | 'danger'
    | 'secondary'
    | 'contrast' {

    const texto =`${estado} ${accion}`.toLowerCase();

    if (
      texto.includes('aproba') ||
      texto.includes('finaliz') ||
      texto.includes('activo')
    ) {
      return 'success';
    }

    if (
      texto.includes('rechaz') ||
      texto.includes('error')
    ) {
      return 'danger';
    }

    if (
      texto.includes('archiv') ||
      texto.includes('expediente')
    ) {
      return 'warn';
    }

    if (
      texto.includes('envi') ||
      texto.includes('recib')
    ) {
      return 'info';
    }

    return 'secondary';
  }

  // ==========================================================
  // REFRESH TIMELINE
  // ==========================================================

  refrescarTimeline(): void {
    this.cargarTimeline();
  }

  // ==========================================================
  // RESPONSIVE FORM
  // ==========================================================

  changeColumns(
    event: Event
  ): void {
    const target =event.target as HTMLSelectElement;
    this.currentColumns = parseInt(target.value);
  }

  getGridClasses(): string {
    const baseClasses =
      'grid gap-4';
    switch (
      this.currentColumns
    ) {
      case 1:
        return `
          ${baseClasses}
          grid-cols-1
        `;
      case 2:
        return `
          ${baseClasses}
          grid-cols-1
          md:grid-cols-2
        `;
      case 3:
        return `
          ${baseClasses}
          grid-cols-1
          md:grid-cols-2
          lg:grid-cols-3
        `;

      case 4:
        return `
          ${baseClasses}
          grid-cols-1
          gap-1
          md:grid-cols-2
          md:gap-2
          lg:grid-cols-3
          lg:gap-4
          xl:grid-cols-4
          xl:gap-3
        `;

      default:
        return `
          ${baseClasses}
          grid-cols-1
          md:grid-cols-2
        `;
    }
  }

  // ==========================================================
  // FORM
  // ==========================================================

  resetForm(): void {
    this.formGroup.reset();
    this.showFormData = false;
  }

  private markAllFieldsAsTouched(): void {
    Object.keys(
      this.formGroup.controls
    ).forEach(
      key => {
        this.formGroup
          .get(key)
          ?.markAsTouched();
      }
    );
  }
  // ==========================================================
  // VALIDACIONES
  // ==========================================================

  getErrorMessage(fieldName: string,form: FormGroup): string {

    const control = form.get(fieldName);
    if (
      !control?.errors
    ) {
      return '';
    }

    const errors = control.errors;

    if (errors['required']
    ) {
      return `${this.getFieldDisplayName(fieldName)
      } es obligatorio`;
    }

    if (errors['minlength']) {
      return `${this.getFieldDisplayName(fieldName)
      } debe tener al menos ${errors['minlength'].requiredLength} caracteres`;
    }

    if (
      errors['maxlength']
    ) {

      return `${
        this.getFieldDisplayName(
          fieldName
        )
      } no puede tener más de ${
        errors['maxlength']
          .requiredLength
      } caracteres`;
    }

    if (
      errors['min']
    ) {

      return `${
        this.getFieldDisplayName(
          fieldName
        )
      } debe ser mayor a ${
        errors['min'].min
      }`;
    }

    return 'Campo inválido';
  }


  private getFieldDisplayName(fieldName: string): string {
    const displayNames:
      Record<string, string> = {
        id: 'ID',
        nombre: 'Nombre',
        Estado: 'Estado',
        observacion:'Observación',
      };

    return (
      displayNames[fieldName] ||
      fieldName
    );
  }

  // ==========================================================
  // CARGA INICIAL
  // ==========================================================

  loadInitialData(): void {

    this.generalService
      .getInitialParameters$()
      .subscribe({

        next: (response:IResponseApiGeneric<IConfiguracionSistema>
        ) => {
          if (
            response?.status === TypeResponse.OK && response.data?.ProgramasPermisosList
          ) {

            this.programasPermisos = response.data.ProgramasPermisosList[0];
            this.setProgramaPermisos(this.programasPermisos);

          } else {

            this.messageService.add({
              severity: 'warn',
              summary:'Advertencia',
              detail:'Sin Permisos en la carga inicial',
              life: 10000,
            });
          }
        },
        error: (err) => {
          this.messageService.add({
            severity: 'error',
            summary:'Error',
            detail:'Error al cargar los datos iniciales',
            life: 3000,
          });
        },
        complete: () => {},
      });
  }

  // ==========================================================
  // PERMISOS
  // ==========================================================

  override setProgramaPermisos(programasPermisos:IProgramaPermiso): void {
    console.table(programasPermisos);
    /*
    this.permissonService
      .setActiveProgramAndButtons(
        programasPermisos.CodPrograma,
        [
          'Grabar',
          'Editar',
          'Ejecutar'
        ]
      );

    this.tableService.CodProgram =
      programasPermisos.CodPrograma;

    this.permissonService
      .setPermissionsForProgram(
        programasPermisos
      );
    */
  }

  // ==========================================================
  // VER DOCUMENTOS CONCATENADOS
  // ==========================================================

  onVerDocumentosConcatenados(): void {

    const record = this.config.data?.record;
    if (!record?.IdfdArchivo) {
      return;
    }

    this.generalService.getPDFsByPaquete(record.IdfdArchivo, true).subscribe({
        next: (
          response
        ) => {

          if (!response?.data?.fileBase64) {
            this.messageService.add({
              severity: 'warn',
              summary:'Sin datos',
              detail:'No se encontró información del documento.',
            });
            return;
          }

          this.dialogService.open(FilePreviewComponent,
            {
              header:`Vista previa - Documento ${record.IdfdArchivo}`,
              width:'90vw',
              modal: true,
              closable: true,
              dismissableMask:true,
              maximizable:true,
              contentStyle: {
                'max-height':
                  '90vh',
                'border-radius':
                  '8px',
                'box-shadow':
                  '0 10px 30px rgba(51, 27, 27, 0.2)',
              },

              templates: {
                footer:
                  FooterComponent,
              },
              data: {
                fileType:
                  EFileType.PdfBase64,
                fileUrl: [
                  response
                    .data
                    .fileBase64
                ],
              },
            }
          );
        },

        error: (err) => {
          console.error(err);
          this.messageService.add({
            severity:
              'error',
            summary:
              'Error',
            detail:
              'No se pudo obtener el archivo PDF',
          });
        },
      });
  }

  // ==========================================================
  // COMPARAR DOCUMENTOS
  // ==========================================================

  onComparar(): void {

    const datos =this.tableService.currentDataTable;
    const lista = datos?.data ?? [];
    const record =this.config.data?.record;

    if (!record) {
      return;
    }

    const ref = this.dialogService.open(ModalGenericComponent,
        {
          header: 'Seleccione un Documento',
          width: '40vw',
          height:'30vh',
          modal:true,
          closable: true,
          dismissableMask:true,
          maximizable: true,
          data: {
            title:'¡Selección de un Registro!',
            message:'Seleccione un documento para comparar:',
            tipoConfirmacion: 'success',
            confirmLabel:'Comparar',
            cancelLabel:'Cancelar',
            documentos:
              lista.map(
                (
                  d: any
                ) => ({

                  label:
                    `${d.IdfdArchivo}`,

                  value:
                    d.IdfdArchivo,
                })
              ),
          },
        }
      );

    ref.onClose.subscribe((selectedId:number | null) => {
          if (
            !selectedId
          ) {
            return;
          }

          const pdfArchivo$ = this.generalService.getPDFByArchivo(selectedId,true);
          const pdfPaquete$ = this.generalService.getPDFsByPaquete(record.IdfdArchivo,true);

          forkJoin([pdfArchivo$, pdfPaquete$])
            .subscribe({

              next: (
                [
                  resArchivo,
                  resPaquete,
                ]
              ) => {

                const base64_1 = resArchivo?.data?.fileBase64 ||null;
                const base64_2 = resPaquete?.data?.fileBase64 ||null;

                if (!base64_1 ||!base64_2) {this.messageService.add({
                    severity:'warn',
                    summary:'Sin datos',
                    detail:'No se encontraron archivos PDF para comparar.',
                  });
                  return;
                }

                this.dialogService.open(FilePreviewComponent,{
                    header:'Comparación de documentos',
                    width:'90vw',
                    height:'90vh',
                    modal: true,
                    closable: true,
                    maximizable:true,
                    dismissableMask: true,
                    templates: {
                      footer:
                        FooterComponent,
                    },
                    data: {
                      fileType: EFileType.PdfBase64,
                      fileUrl: [base64_1,base64_2,],
                    },
                  }
                );
              },

              error: (err) => {

                this.messageService.add({
                  severity:
                    'error',
                  summary:
                    'Error',
                  detail:
                    'No se pudieron obtener los archivos para comparar.',
                });
              },
            });
        }
      );
  }

  // ==========================================================
  // UTILIDAD
  // ==========================================================

  /**
   * Permite obtener un valor del registro
   * evitando errores cuando viene null.
   */
  getValue(
    registro: any,
    campo: string
  ): any {

    return registro?.[campo] ??
      'No disponible';
  }

  /**
   * Determina si existe observación.
   */
  tieneObservacion(
    evento: ITimelineDocumento
  ): boolean {

    return !!(
      evento.observacion &&
      evento.observacion.trim()
    );
  }

  /**
   * Formatea fecha del Timeline.
   */
  formatearFecha(fecha: Date | string): string {

    if (!fecha) {
      return 'Sin fecha';
    }

    const date = new Date(fecha);
    if (isNaN(date.getTime())) {
      return String(fecha);
    }

    return date.toLocaleString(
      'es-CO',
      {
        year:'numeric',
        month:'2-digit',
        day:'2-digit',
        hour:'2-digit',
        minute:'2-digit',
      }
    );
  }

  // ==========================================================
  // TRACKBY
  // ==========================================================

  trackByTimeline(
    index: number,
    item: ITimelineDocumento
  ): string | number {

    return (
      item.original?.IdfdArchivo ??
      item.consecutivo ??
      index
    );
  }

  formatearMoneda(valor: any): string {
    if (
      valor === null ||
      valor === undefined ||
      valor === ''
    ) {
      return 'No disponible';
    }

    const numero = Number(valor);

    if (isNaN(numero)) {
      return String(valor);
    }

    return numero.toLocaleString(
      'es-CO',
      {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }
    );
  }
}